/**
 *  定义动作事情,主要用来处理请求
 *  所有的动作都分为3部分
 */
import RequestJson from '../model/RequestJson'
import SQLBuilderItem from '../model/SQLBuilderItem'

export default class EventFactory {

  constructor (_model) {
    this.sqlItems = []            //SQLItem对象
    this.model = _model           //json对象
    this.enabled = true           //控制事件是否生效
    this.executed = true          //执行后的结果状态(false表示不继续执行)
    this.selectParam = new Map()  //查询参数
    this.executeParam = []        //执行参数
  }

  onBeforeExecute (target) {

  }

  onExecuting (target) {

  }

  onAfterExecute (target) {

  }

  /**
   * 事件执行，分3个动作，前，中，后，方便实际处理业务逻辑
   * @return {Promise<void>}
   */
  async execute () {
    if (!this.enabled) return
    this.executed = true
    // 1.前
    if (this.executed) {
      this.onBeforeExecute(this)
    }
    // 2.网络操作=>提交数据
    if (this.executed && this.model && this.sqlItems.length > 0) {
      this.executed = await this.commit()
    }
    // 3.中
    if (this.executed && this.onExecuting) {
      this.onExecuting(this)
    }
    // 4.后
    if (this.executed && this.onAfterExecute) {
      this.onAfterExecute(this)
    }
    //解决当发生错误时按钮事件就不能使用
    this.executed = true
  }

  /**
   * 构造请求参数RequestJson对象,调用Commit方法提交数据
   * @returns {Promise}
   * @private
   */
  commit () {
    // 构造请求参数
    this.model.request = new RequestJson()
    for (let _item of this.sqlItems) {
      //判断enabled是否可用
      if (Object.keys(_item).includes('enabled') && !_item.enabled) continue
      //构造SQLBuilderItem
      let _SQLBuilderItem = new SQLBuilderItem()
      _SQLBuilderItem.SQLBuilderID = _item.sid
      _SQLBuilderItem.TableName = _item.tableName
      _SQLBuilderItem.Caption = _item.tableCaption
      if (_item.kind.toLowerCase() === 'execute') {
        //执行条件,把map中的值放到select中
        for (let _row of this.executeParam) {
          _SQLBuilderItem.Execute.push(_row)
        }
      }
      else if (_item.kind.toLowerCase() === 'save') {
        //保存
        this._rowsToJson(_SQLBuilderItem)
      }
      else if (_item.kind.toLowerCase() === 'select') {
        //查询条件,把map中的值放到select中
        for (let [k, v] of this.selectParam) {
          _SQLBuilderItem.Select[k] = v
        }
      }
      this.model.request.add(_SQLBuilderItem)
    }
    return this.model.commit()
  }

  /**
   * 把要提交的数据构造到SQLBuilderItem中的Save节点
   * @param _SQLBuilderItem
   * @private
   */
  _rowsToJson (_SQLBuilderItem) {
    let _rows = this.model.tableJson(_SQLBuilderItem.SQLBuilderID)
    //这里不能能判断length < 1,因为如果把源数据的值都删掉后，应该是把备份数据的RowState都改成2，而不是return
    if (!_rows) return
    //旧数据
    let _backup = this.model.backupJson(_SQLBuilderItem.SQLBuilderID)
    //通过RowState来区分新增，修改，删除
    //RowState有4中状态:2-删除,4-新增,(8-修改,1-原始数据)
    //先处理删除数据
    for (let _row of _backup) {
      let _exists = _rows.some(_item => _item.FMID === _row.FMID)
      if (!_exists) {
        _row.RowState = '2'
        _SQLBuilderItem.Save.push(_row)
      }
    }
    for (let _row of _rows) {
      let _original = _backup.find(_item => _item.FMID === _row.FMID)
      if (_original) {
        //比较是否有差异
        let _modify = this._compareModify(_row, _original)
        if (_modify) {
          _original.RowState = '1'  //原始记录
          _SQLBuilderItem.Save.push(_original)
          _row.RowState = '8'  //修改记录
          _row.FFID = undefined
          _row.FLASTCHANGED = undefined
          _SQLBuilderItem.Save.push(_row)
        }
      }
      else {
        _row.RowState = '4'  //新增状态
        // _row.FFID = undefined;
        // _row.FLASTCHANGED = undefined;
        _SQLBuilderItem.Save.push(_row)
      }
    }
  }

  /**
   * @param _row
   * @param _item
   * @returns {boolean}
   * @private
   */
  _compareModify (_row, _original) {
    let {keys} = Object
    for (let _key of keys(_row)) {
      if ('FFID,FLASTCHANGED,RowState'.includes(_key)) continue
      if (_row[_key] !== _original[_key]) {
        return true
      }
    }
    return false
  }

}


// WEBPACK FOOTER //
// ./src/wbap-core-commit/commit/eventFactory.js